import { render, staticRenderFns } from "./TituloRelatorioDescontosContrato.vue?vue&type=template&id=95863bc2&"
import script from "./TituloRelatorioDescontosContrato.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioDescontosContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports